import { User } from '../types/User';
import { ApiResponse } from '../types/ApiResponse';
import { post, get } from './api';

interface LoginData {
  email: string;
  password: string;
}

interface RegisterData extends LoginData {
  username: string;
}

export const login = async (data: LoginData): Promise<ApiResponse<{ user: User; token: string }>> => {
  const response = await post<{ user: User; token: string }>('/auth/login', data);
  
  if (response.success && response.data) {
    // Store token in localStorage
    localStorage.setItem('token', response.data.token);
    // console.log('Stored token:', localStorage.getItem('token'));
  }
  
  return response;
};

export const register = async (data: RegisterData): Promise<ApiResponse<{ user: User; token: string }>> => {
  const response = await post<{ user: User; token: string }>('/auth/register', data);
  
  if (response.success && response.data) {
    // Store token in localStorage
    localStorage.setItem('token', response.data.token);
    // console.log('Stored token:', localStorage.getItem('token'));
  }
  
  return response;
};

export const logout = (): void => {
  localStorage.removeItem('token');
};

export const getCurrentUser = async (): Promise<ApiResponse<User>> => {
  return await get<User>('/auth/me');
};

export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('token');
};